import { Col, Container, Row } from "reactstrap"
import { convertCurrency } from "../../../../utility/Utils"
import styles from "./styles.module.scss"
import FilterInTable from "../../../Manage/FilterInTable"
import DataTable from "react-data-table-component"
import PaginationComponent from "../../../Manage/PaginationComponent"
import { useEffect, useState } from "react"
import CustomDropdown from "../../../../components/common/Dropdown/CustomDropDown"
import SellerActionDropdown from "../../../../components/common/SellerCommonComponents/SellerActionDropdown/SellerActionDropdown"

const PurchaseHistory = () => {
  const [itemsPerPage, setItemsPerPage] = useState(3)
  const [currentPage, setCurrentPage] = useState(1)
  const [currentItems, setCurrentItems] = useState([])

  const metricesCol1Data = [
    { label: "Total Number of Customers:", value: convertCurrency(1500) },
    { label: "Average Purchase Frequency:", value: "4 purchases per month" },
    { label: "Average Order Value (AOV):", value: 75 },
    { label: "Customer Retention Rate:", value: "60%" },
    { label: "Repeat Customer Rate:", value: 3 },
  ]

  const metricesCol2Data = [
    { label: "Customer Lifetime Value (CLV):", value: 450 },
    { label: "Churn Rate:", value: 15 },
    { label: "Most Popular Product:", value: "Eco Travel Mug" },
    { label: "Seasonal Purchase Peak:", value: "November/December" },
    { label: "New vs. Returning Customer Sales:", value: "40% New / 60% Returning" },
  ]

  const tableData = [
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
    { customerId: "001", customerName: "William John", totalPurchases: 5, lastPurchaseDate: "02/06/2024", totalSpent: "250.00", mostPurchasedProduct: "Shirt" },
  ]

  const actions = [
    { label: 'View details' },
    { label: 'Print' },
    { label: 'Contact' },
  ]

  const columns = [
    {
      name: "Customer ID",
      selector: (row) => row.customerId,
    },
    {
      name: "Customer name",
      selector: (row) => row.customerName,
    },
    {
      name: "Total Purchases",
      selector: (row) => row.totalPurchases,
    },
    {
      name: "Last Purchase Date",
      selector: (row) => row.lastPurchaseDate,
    },
    {
      name: "Total Spent",
      selector: (row) => row.totalSpent,
    },
    {
      name: "Most Purchased Product",
      selector: (row) => row.mostPurchasedProduct,
    },
    {
      name: "Action",
      cell: () => <SellerActionDropdown options={actions} />,
    },
  ]

  const handlePageChange = (page) => {
    setCurrentPage(page)
    const startIndex = (page - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    setCurrentItems(tableData.slice(startIndex, endIndex))
  }

  const handleRowsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage)
    setCurrentPage(1)
    handlePageChange(1)
  }

  useEffect(() => {
    handlePageChange(currentPage)
  }, [currentPage, itemsPerPage])

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#FBBD34",
        color: "#ffffff",
        fontSize: "1rem",
        fontWeight: 600,
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
        borderBottom: "1px solid #ddd",
        borderRight: "1px solid #ddd",
      },
    },
  }

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100vh", paddingBlock: "1rem" }}>
      <Container fluid>
        <h4 className="fw-semibold mb-3">Purchase History</h4>
        <h5 className="fw-semibold my-3">Metrices</h5>

        <Row className="my-3 gy-2 gy-lg-0 row-cols-1 row-cols-lg-2">
          <Col className="d-grid">
            <div className="rounded border border-black bg-white p-3 fw-medium">
              {metricesCol1Data.map((item, index) => (
                <Row className="g-0" key={index}>
                  <Col>{item.label}</Col>
                  <Col style={{ color: "#EC7426" }}>{item.value}</Col>
                </Row>
              ))}
            </div>
          </Col>
          <Col className="d-grid">
            <div className="rounded border border-black bg-white p-3 fw-medium">
              {metricesCol2Data.map((item, index) => (
                <Row className="g-0" key={index}>
                  <Col>{item.label}</Col>
                  <Col style={{ color: "#EC7426" }}>{item.value}</Col>
                </Row>
              ))}
            </div>
          </Col>
        </Row>

        <h5 className="fw-semibold my-3">Customer Purchase History</h5>
        <div className={`p-3 ${styles["outer-wrapper"]}`}>
          <FilterInTable componentName="Purchase History" />

          <div className="mt-3" />

          <DataTable data={currentItems} columns={columns} customStyles={customStyles} responsive={true} />
          <PaginationComponent
            totalItems={tableData.length}
            siblingCount={2}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </div>
      </Container>
    </div>
  )
}

export default PurchaseHistory
